import * as Yup from 'yup'
import { NotificationDisplayType } from '@/redux/types/notifications'

export interface NotificationModalValues {
  message: string
  displayType: NotificationDisplayType
}

export const notificationValidationSchema = Yup.object({
  message: Yup.string()
    .trim()
    .required('Message is required')
    .min(1, 'Message cannot be empty')
    .max(500, 'Message cannot exceed 500 characters'),
  displayType: Yup.mixed<NotificationDisplayType>()
    .oneOf(
      [
        NotificationDisplayType.BELL_ICON,
        NotificationDisplayType.MODAL_CENTER_AUTO_DISMISS,
      ],
      'Invalid display type'
    )
    .required('Display type is required'),
})
